import api from '@/modules/api.service';
import { ReadDefensorResponseDto } from '@/api.types';

/**
 * Busca defensores vinculados ao assessor (colaborador) identificado pelo CPF.
 * Retorna apenas vínculos ativos com permissão `permite_editar_relatorio_defensor`.
 */
export async function buscarDefensoresVinculadosAssessorUseCase(
  cpf: string,
): Promise<ReadDefensorResponseDto[]> {
  try {
    const response = await api.get(`/defensor/vinculados-assessor/${cpf}`);
    return response.data ?? [];
  } catch {
    return [];
  }
}
